import api from "../../api/cofocusAPI";
import store from "../../store";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

/**
 * To reduce file size and repetitiveness
 * TODO: move this to cofocusAPI
 */
async function getResponseData(requestConfig) {
  // eslint-disable-line no-unused-vars
  try {
    const response = await api.REQUEST(requestConfig);
    if (response && response.data && response.data.success) {
      return response.data;
    }
    if (response.status === 200) {
      return response.data;
    }
    console.log("Response DATA: ", response);
  } catch (error) {
    console.error("error with config: ", requestConfig);
  }
  return null;
}

async function getUpcomingSession(sessionID, userID) {
  console.log("@getUpcomingSessions arguments", sessionID, userID);
  try {
    const response = await api.REQUEST({
      method: "get",
      url: `/api/sessions/upcoming/${sessionID}`,
      params: {
        UID: userID,
      },
      withCredentials: true,
    });
    console.log("@getUpcomingSessions response: ", response);
    console.log("@getUpcomingSessions status: ", response.status === 400);
    console.log("@getUpcomingSessions second: ", response.data && !response.data.success);
    console.log("@getUpcomingSessions third: ", response.data.error === "no session");
    if (response.data && response.data.success) {
      response.data.isCompleted = false;
      return response.data;
    } else if (response.status === 400 && response.data && !response.data.success && response.data.error === "no session") {
      const pastResponse = await api.REQUEST({
        method: "get",
        url: `/api/sessions/past/${sessionID}`,
        params: {
          UID: userID,
        },
        withCredentials: true,
      });
      if (pastResponse.data && pastResponse.data.success) {
        pastResponse.data.isCompleted = true;
        return pastResponse.data;
      }
    }
    return response.data;
  } catch (error) {
    console.error("FAIL @getUpcomingSession", error);
  }
  return null;
}

async function getTwilioAccessToken(userID) {
  return getResponseData({
    method: "post",
    url: "/api/external/twilio-access-token",
    data: {
      identity: userID,
    },
    withCredentials: true,
  });
}

async function getSessionPreferences(userID) {
  console.log("@getSessionPreferences: ", userID);

  return getResponseData({
    url: `/api/users/${userID}/sessionPreferences`,
    method: "get",
    params: {
      UID: userID,
    },
    withCredentials: true,
  });
}

async function updateSessionPreferences(sessionPreferences, userID) {
  console.log("@updateSessionPreferences: ", sessionPreferences, userID);
  return getResponseData({
    url: `/api/users/${userID}/sessionPreferences`,
    method: "post",
    data: {
      sessionPreferences,
    },
    params: {
      UID: userID,
    },
    withCredentials: true,
  });
}

async function cancelOneRematchRequestOverHTTP(SID, UID) {
  if (!SID || !UID) {
    return console.log("Information not provided for request.");
  }
  return getResponseData({
    method: "post",
    url: `/api/sessions/cancelRematchRequest/${SID}`,
    data: { SID, UID },
    withCredentials: true,
  });
}

/**
 * @param {String} SID a session's ID
 */
async function addTimestamp(SID, timestampData) {
  if (!SID || !timestampData) {
    return console.log("Information not provided for request.");
  }
  return getResponseData({
    method: "post",
    url: `/api/sessions/${SID}/timestamp`,
    data: timestampData,
    withCredentials: true,
  });
}

async function logSessionError(error) {
  if (!error) return console.log("Information not provided for request.");

  const SID = store.state.session.sessionID;
  const UID = AuthStore.user._id;
  const dateTimeMS = store.state.session.dateTimeMS;
  const errorData = { message: error.message ?? "undefined" };
  if (error.name) errorData.name = error.name;
  if (error.code) errorData.code = error.code;
  if (error.type) errorData.type = error.type;
  if (error.data) errorData.data = error.data;
  return getResponseData({
    method: "post",
    url: `/api/sessions/${SID}/error`,
    data: { SID, UID, dateTimeMS, error: errorData },
    withCredentials: true,
  });
}

export default {
  getUpcomingSession,
  addTimestamp,
  getTwilioAccessToken,
  updateSessionPreferences,
  getSessionPreferences,
  cancelOneRematchRequestOverHTTP,
  logSessionError,
};
